export default __webpack_public_path__ + "static/media/step_6.40d69851.png";